import { message, WidgetUtilsContext } from '@homemaster/jslib'
import BookOnlineIcon from '@mui/icons-material/BookOnline'
import BugReportIcon from '@mui/icons-material/BugReport'
import BusinessIcon from '@mui/icons-material/Business'
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'
import DashboardIcon from '@mui/icons-material/Dashboard'
import SchoolIcon from '@mui/icons-material/School'
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { zhCN as muiZhCN } from '@mui/x-date-pickers/locales'
import { LicenseInfo } from '@mui/x-license'
import { zhCN } from 'date-fns/locale'
import { useEffect } from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import MainWindow, { type NavItem } from './MainWindow'
import CouponTemplatesPage from './pages/CouponTemplatesPage'
import CoursesPage from './pages/CoursesPage'
import DashboardPage from './pages/DashboardPage'
import IotControlPointsPage from './pages/IotControlPointsPage'
import OrdersPage from './pages/OrdersPage'
import EditSitePage from './pages/SitesPage/EditSitePage'
import SlotsPage from './pages/SlotsPage'
import SlotTemplatePage from './pages/SlotTemplatePage'
import StaffPage from './pages/StaffPage'
import SystemTestPage from './pages/SystemTestPage'
import UserCouponsPage from './pages/UserCouponsPage'
import widgetUtils from './widgetUtils'

// register MUI-X license key, expires on Jan. 25, 2027
LicenseInfo.setLicenseKey(
  '64a59fe7cef759ee6dc51c9b876f1d97Tz0xMjM3MzgsRT0xODAwOTIxNTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y',
)

export const navItems: NavItem[] = [
  { text: '数据看板', icon: <DashboardIcon />, path: '/dashboard' },
  { text: '场地管理', icon: <BookOnlineIcon />, path: '/slots' },
  { text: '订单管理', icon: <ShoppingCartIcon />, path: '/orders' },
  { text: '课程管理', icon: <SchoolIcon />, path: '/courses' },
  {
    group: '优惠券',
    icon: <CardGiftcardIcon />,
    superAdminOnly: true,
    children: [
      { text: '模板管理', path: '/coupon-templates' },
      { text: '用户优惠券', path: '/user-coupons' },
    ],
  },
  {
    group: '场馆管理',
    icon: <BusinessIcon />,
    children: [
      { text: '时段模板', path: '/slot-templates' },
      { text: '人员设置', path: '/staff', superAdminOnly: true },
      { text: '场馆设置', path: '/site/edit' },
    ],
  },
  {
    text: '设备控制',
    icon: <SettingsRemoteIcon />,
    path: '/iot',
  },
  {
    text: 'Test',
    icon: <BugReportIcon />,
    path: '/test',
    superAdminOnly: true,
    devOnly: true,
  },
]

/** Site app main window */
function SiteMainWindow() {
  return <MainWindow navItems={navItems} />
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <SiteMainWindow />,
    children: [
      { index: true, element: <Navigate to="/slots" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'slots', element: <SlotsPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'courses', element: <CoursesPage /> },
      { path: 'slot-templates', element: <SlotTemplatePage /> },
      { path: 'staff', element: <StaffPage /> },
      { path: 'coupon-templates', element: <CouponTemplatesPage /> },
      { path: 'user-coupons', element: <UserCouponsPage /> },
      { path: 'iot', element: <IotControlPointsPage /> },
      { path: 'site/edit', element: <EditSitePage /> },
      { path: 'test', element: <SystemTestPage /> },
    ],
  },
])

function AppMain() {
  useEffect(() => {
    message.init()
  }, [])

  return (
    <WidgetUtilsContext value={widgetUtils}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={zhCN}
        localeText={muiZhCN.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <RouterProvider router={router} />
      </LocalizationProvider>
    </WidgetUtilsContext>
  )
}

export default AppMain
